export default "<app-engine\n  [fieldOfView]=\"75\"\n  [nearClipping]=\"1\"\n  [farClipping]=\"1000\"\n>\n</app-engine>\n"